// extracted by mini-css-extract-plugin
export default {"dropzone":"TabSeiModale_dropzone__3cnEd","activeDropzone":"TabSeiModale_activeDropzone__SxenX","dialog":"TabSeiModale_dialog__DO-YZ"};